/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EnumOption1
 */
export interface EnumOption1 {
    /**
     * 枚举值
     * @type {number}
     * @memberof EnumOption1
     */
    value?: number;
    /**
     * 显示名称（国际化）
     * @type {string}
     * @memberof EnumOption1
     */
    label?: string;
}

/**
 * Check if a given object implements the EnumOption1 interface.
 */
export function instanceOfEnumOption1(value: object): value is EnumOption1 {
    return true;
}

export function EnumOption1FromJSON(json: any): EnumOption1 {
    return EnumOption1FromJSONTyped(json, false);
}

export function EnumOption1FromJSONTyped(json: any, ignoreDiscriminator: boolean): EnumOption1 {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
        'label': json['label'] == null ? undefined : json['label'],
    };
}

export function EnumOption1ToJSON(json: any): EnumOption1 {
    return EnumOption1ToJSONTyped(json, false);
}

export function EnumOption1ToJSONTyped(value?: EnumOption1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'label': value['label'],
    };
}

